import { gql } from "@apollo/client";

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($invitationMrn: ID!) {
    resendInvitation(invitationMrn: $invitationMrn)
  }
`;
